import { createSlice } from '@reduxjs/toolkit'

const initState = {}

export const loginSlice = createSlice({
  name: 'login',
  initialState: initState,
  reducers: {
    login: (state, action) => {
      return action.payload
    },
    logout: (state) => {
      return initState
    },
  }
})

export const { login, logout } = loginSlice.actions
export default loginSlice.reducer